export const checkForNoYAxisOffset = (
  element: HTMLElement,
  timeIntervalForChecking: number = 100
): Promise<void | Error> => {
  return new Promise((resolve, reject): void => {
    let intervalId: number | null = null
    let lastKnownPosition: number | null = element.getBoundingClientRect().top

    const checkPosition = (): void => {
      const currentPosition: number = element.getBoundingClientRect().top
      if (currentPosition === lastKnownPosition) {
        if (intervalId !== null) {
          clearInterval(intervalId)
          resolve()
        }
      } else {
        lastKnownPosition = currentPosition
      }
    }

    try {
      intervalId = window.setInterval(checkPosition, timeIntervalForChecking)
    } catch (error) {
      if (intervalId !== null) {
        clearInterval(intervalId)
      }

      reject(error)
    }
  })
}
